import React, { useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import axios from 'axios';
import { toast } from 'react-toastify';
import CustomTab from '../../../components/common/CustomTab';
import BannerAppConfig from './BannerAppConfig';
import TermsAndConditionConfig from './TermsAndConditionConfig';
import HelpCenterConfig from './HelpCenterConfig';
import { postmobileBannerConfig } from '../../../utils/urls';
import CustomIconButton from '../../../components/common/CustomButton copy/CustomIconButton';

const MobileConfigurations = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const initialValues = {
        banner: {
            title: '',
            description: '',
            fileType: '',
            file: null,
            enabled: true,
        },
    };

    const SUPPORTED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
    const SUPPORTED_VIDEO_TYPES = ['video/mp4', 'video/webm'];

    const bannerValidationSchema = Yup.object({
        title: Yup.string().required('Title is required'),
        description: Yup.string().required('Description is required'),
        fileType: Yup.string()
            .oneOf(['image', 'video'])
            .required('File type is required'),
        file: Yup.mixed()
            .required('File is required')
            .test('file-type', 'Invalid file type', function (value) {
                const { fileType } = this.parent;
                if (!value || !(value instanceof File)) return false;
                if (fileType === 'image') return SUPPORTED_IMAGE_TYPES.includes(value.type);
                if (fileType === 'video') return SUPPORTED_VIDEO_TYPES.includes(value.type);
                return false;
            }),
    });

    const handleBannerSubmit = async ({ title, description, enabled, file }) => {
        setIsLoading(true);
        const formData = new FormData();
        formData.append('title', title);
        formData.append('description', description);
        formData.append('is_active', enabled);
        if (file) formData.append('file', file);

        try {
            await axios.post(postmobileBannerConfig, formData);
            toast.success('Banner configuration saved successfully!');
        } catch (error) {
            console.error('Banner config error:', error);
            toast.error('Failed to submit banner configuration.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="w-full p-4 pt-0 mb-10">
            <div className="flex items-center gap-4 mb-6">
                <CustomIconButton
                    onClick={() => navigate(-1)}
                    icon={<ArrowLeft />}
                    type="button"
                />
                <h1 className="text-2xl font-semibold text-blue-900">Mobile App Config</h1>
            </div>

            <CustomTab
                tabList={[
                    {
                        title: 'Banner',
                        component: (
                            <BannerAppConfig
                                bannerInitialValues={initialValues.banner}
                                handleBannerSubmit={handleBannerSubmit}
                                bannerValidationSchema={bannerValidationSchema}
                                isLoading={isLoading}
                            />
                        ),
                    },
                    {
                        title: 'Terms & Conditions',
                        component: <TermsAndConditionConfig />,
                    },
                    {
                        title: 'Help Center',
                        component: <HelpCenterConfig />,
                    },
                ]}
            />
        </div>
    );
};

export default MobileConfigurations;
